module.exports = __webpack_public_path__ + "img/bim (1).3c0f86ee.png";